import React from 'react';
import { useDispatch } from 'react-redux';

// Components.
import formatTimeago from 'app/utils/formatTimeago';
import PostCardWrapper from 'app/components/post/PostCardWrapper';
import { setEditOpinionDraftId } from 'app/dispatcher/draftDispatcher';
import { Opinion } from 'entity/opinion/opinionTypes';
import useDraftOpinionMenu from './hooks/useDraftOpinionMenu';
import OpinionBody from './OpinionBody';

const OpinionDraftItem = ({ opinion }: { opinion: Opinion }) => {
  const dispatch = useDispatch();

  const { id, updatedAt } = opinion;

  const dateText = formatTimeago(updatedAt);
  const menuOptions = useDraftOpinionMenu({ opinion });

  return (
    <PostCardWrapper menuOptions={menuOptions}>
      <div className="flex flex-col w-full gap-4">
        <p className="text-xs">{`Edited ${dateText}`}</p>
        <div className="horizontal-divider" />
        <OpinionBody
          opinion={opinion}
          titleLink="/post-opinion"
          titleOnClick={() => dispatch(setEditOpinionDraftId(id))}
        />
      </div>
    </PostCardWrapper>
  );
};

export default OpinionDraftItem;
